import React from 'react';
import ContactTitle, {CTTitle} from './ContactTitle'
import qr_code_img from '../images/qr-code-img.jpg'
import cell_phone_title_icon from '../images/cell-phone-title-icon.png'
import './CellPhone.css'

export default function CellPhone() {
    return (
        <div className='cell-phone'>
            <ContactTitle src={cell_phone_title_icon}>
                <CTTitle>
                    手机访问网址
                </CTTitle>
            </ContactTitle>
            <div className='qr-code'>
                <img className='qr-code-img' src={qr_code_img} alt='qr-code-img'/>
                <p className='qr-code-text'>
                    扫描上方二维码进入官网
                </p>
            </div>
        </div>
    )
}